import { DEV_MODE_COOKIES, dev_cookie_name } from "@core/helpers/dev-mode-rules";

// storefront dev mode: the login and cart cookies are the replica's own while `_dev_mode` is set (dev-mode-rules.js)
const named = (cookie, name) => dev_cookie_name(name, cookie.has(DEV_MODE_COOKIES.token));

export const get_all_cookies_server = async () => {
  const { cookies } = require("next/headers");
  const cookie = await cookies();
  return cookie.getAll();
};

export const has_cookie_server = async (name = "") => {
  const { cookies } = require("next/headers");
  const cookie = await cookies();
  return cookie.has(named(cookie, name));
};

export const get_cookie_server = async (name = "") => {
  const { cookies } = require("next/headers");
  const cookie = await cookies();
  return cookie.get(named(cookie, name))?.value || "";
};

export const set_cookie_server = async (name = "", value, options = {}) => {
  if (!options?.expires) {
    options = { ...options, expires: Date.now() + 30 * 24 * 60 * 60 * 1000 };
  }

  if (!options?.path) {
    options = { ...options, path: '/' };
  }

  const { cookies } = require("next/headers");
  const cookie = await cookies();
  return cookie.set(named(cookie, name), value, options);
};

export const remove_cookie_server = async (name = "") => {
  const { cookies } = require("next/headers");
  const cookie = await cookies();
  return cookie.delete(named(cookie, name));
};
